export default "__VITE_ASSET__B9QDlrt4__"